/**
 * Claim portal shell: `/` redirects to `/form` unless legacy store lookup is enabled.
 */
import { Navigate, Route, Routes } from "react-router-dom";
import AccountRequestFormPage from "./pages/AccountRequestFormPage";
import ClaimFlowPage from "./pages/ClaimFlowPage";

const enableStoreLookup = import.meta.env.VITE_ENABLE_STORE_LOOKUP === "true";

const App = () => (
  <Routes>
    {enableStoreLookup ? (
      <>
        <Route path="/" element={<ClaimFlowPage />} />
        <Route path="/store-lookup" element={<ClaimFlowPage />} />
      </>
    ) : (
      <Route path="/" element={<Navigate to="/form" replace />} />
    )}
    <Route path="/form/:presetStoreId" element={<AccountRequestFormPage />} />
    <Route path="/form" element={<AccountRequestFormPage />} />
    {/* Short invite links: /TM-CM-BREAUX-BRIDGE (must be before catch-all *) */}
    <Route path="/:storeId" element={<AccountRequestFormPage />} />
    <Route path="*" element={<Navigate to="/form" replace />} />
  </Routes>
);

export default App;
